import { Email, Call, Sms } from '@mui/icons-material';
import AddchartOutlinedIcon from '@mui/icons-material/AddchartOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import Groups from '@mui/icons-material/Groups';
import InsertChartOutlinedTwoToneIcon from '@mui/icons-material/InsertChartOutlinedTwoTone';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import WorkOutlinedIcon from '@mui/icons-material/WorkOutlined';
import { BsPersonCheckFill } from 'react-icons/bs';
import { IoMdAnalytics } from 'react-icons/io';
import { MdOutlineSmartToy } from 'react-icons/md';
import { RiFileSettingsLine, RiChatFollowUpFill } from 'react-icons/ri';
import { SiGoogleanalytics } from 'react-icons/si';

export const jobAnalyticsOptions = [
  { label: 'Job Analytics', icon: <WorkOutlinedIcon />, url: '/analytics/job/jobs-analytics' },
  {
    label: 'Job Posted & Application recieved',
    icon: <WorkHistoryOutlinedIcon />,
    url: '/analytics/job/job-posting-analytics',
  },
];

export const mappingOptions = [
  {
    label: 'Mapping By Time',
    icon: <BsPersonCheckFill />,
    url: '/analytics/mappings/mappings-by-time',
  },
  {
    label: 'Mapping Real Time',
    icon: <BsPersonCheckFill />,
    url: '/analytics/mappings/real-time-analytics',
  },
];

export const submissionsOptions = [
  {
    label: 'Submission Bytime',
    icon: <BsPersonCheckFill />,
    url: '/analytics/submissions/monthly-submissions-analytics',
  },
  {
    label: 'Submission Real Time',
    icon: <BsPersonCheckFill />,
    url: '/analytics/submissions/real-time-analytics',
  },
  {
    label: 'Account Manager Dashboard',
    icon: <Groups />,
    url: '/analytics/submissions/account-manager-analytics',
  },
  {
    label: 'Account Manager Real Time Dashboard',
    icon: <Groups />,
    url: '/analytics/submissions/account-manager-real-time-analytics',
  },
  {
    label: 'Team Leader Dashboard (Beta)',
    icon: <Groups />,
    url: '/analytics/submissions/team-manager-dashboard',
  },
  {
    label: 'Team Leader Real Time Dashboard',
    icon: <AddchartOutlinedIcon />,
    url: '/analytics/submissions/team-leader-real-time-dashboard',
  },
  {
    label: 'Pipeline Report (Beta)',
    icon: <Groups />,
    url: '/analytics/submissions/am-pipeline-report-analytics',
  },
];

export const taskOptions = [
  { label: 'Follow-ups', icon: <RiChatFollowUpFill />, url: '/analytics/task/followup-analytics' },
];

export const leaderBoardsOptions = [
  {
    label: 'Recruiter Leaderboard',
    icon: <InsertChartOutlinedTwoToneIcon />,
    url: '/analytics/job/recruiter-analytics',
  },
  {
    label: 'Team Leaderboard',
    icon: <AddchartOutlinedIcon />,
    url: '/analytics/job/team-analytics',
  },
];

export const loginOptions = [];

export const communicationOptions = [
  { label: 'Email', icon: <Email />, url: '/analytics/communication/emails-analytics' },
  { label: 'SMS', icon: <Sms />, url: '/analytics/communication/SMS-analytics' },
  { label: 'Calls', icon: <Call />, url: '/analytics/communication/calls-analytics' },
];

export const careerPagesOptions = [
  {
    label: 'Career Pages',
    icon: <RiFileSettingsLine size={23} />,
    url: '/analytics/career-pages/careers',
  },
];

export const massMailingOptions = [{ label: 'Mass Mailing', icon: <Email />, url: '' }];

export const clientRelationsOptions = [
  { label: 'AM Performace', icon: <InsightsOutlinedIcon />, url: '' },
  { label: 'Client Recruiter Performance ', icon: <LeaderboardIcon />, url: '' },
  { label: 'AM Leaderboard', icon: <BarChartOutlinedIcon />, url: '' },
];
export const aIAndAutomationOptions = [
  { label: 'AI Usage', icon: <IoMdAnalytics />, url: '' },
  {
    label: 'Automation Usage',
    icon: <SiGoogleanalytics />,
    url: '',
  },
  {
    label: 'Bots',
    icon: <MdOutlineSmartToy />,
    url: '/analytics/bot/bot-analytics',
  },
];

export const botAnalyticsOptions = [
  {
    label: 'Bots',
    icon: <WorkHistoryOutlinedIcon />,
    url: '/analytics/bot/bot-analytics',
  },
];
